import placeholderUrl from '@assets/images/placeholder.png';
import {
    FeaturedItemsContentItemComponentConfig,
    FeaturedItemsContentItemComponentModel,
    HawkSearchComponents,
    HawkSearchGlobal,
    SearchResultsItem
} from '@models';
import { trackingService } from '@services';
import { BaseComponent } from '../../../base.component';
import defaultHtml from './featured-items-content-item.component.hbs';

declare let HawkSearch: HawkSearchGlobal;

export class FeaturedItemsContentItemComponent extends BaseComponent<
    FeaturedItemsContentItemComponentConfig,
    SearchResultsItem,
    FeaturedItemsContentItemComponentModel
> {
    protected override componentName: keyof HawkSearchComponents = 'featured-items-content-item';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    protected override renderContent(): boolean {
        return !!this.data;
    }

    protected override getContentModel(): FeaturedItemsContentItemComponentModel {
        return {
            ...this.data!,
            strings: {
                sale: this.configuration?.strings?.sale ?? 'Sale'
            }
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll('[hawksearch-image]').forEach((e) => {
            e.addEventListener('error', (event: Event): void => {
                const element = event.currentTarget as HTMLImageElement;

                element.src = HawkSearch.config.placeholderImageUrl || placeholderUrl;
            });
        });

        this.rootElement.querySelectorAll('[hawksearch-link]').forEach((e) => {
            e.addEventListener('click', ((event: PointerEvent): void => {
                if (!this.data) {
                    return;
                }

                trackingService.trackSearchResultClick(this.data.id, this.data.url, event);
            }) as EventListener);
        });
    }
}
